import React, { useState } from 'react';
import { SubscriptionPackageFeatures } from '@C/Utils';
import { authHeader } from '@H';
import axios from 'axios';
import { toast } from 'react-toastify';
import ExistingPackages from './ExistingPackages';
import { set } from 'lodash';

const Packages = () => {
  const [packageName, setPackageName] = useState({
    package_name: '',
    notes: '',
    feature_modules: [],
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [updated, setUpdated] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPackageName((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handlePackageChange = (selectedOptions) => {
    setPackageName((prevState) => ({
      ...prevState,
      feature_modules: selectedOptions,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const headers = authHeader(1);
    axios
      .post(
        `${process.env.API_URL}/subscription/create-subscription-package/`,
        packageName,
        {
          headers,
        },
      )
      .then(() => {
        toast.success('Package added successfully', {
          position: 'bottom-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setPackageName({
          package_name: '',
          notes: '',
          feature_modules: [],
        });
        setIsSubmitting(false);
        setUpdated(!updated);
      })
      .catch((err) => {
        toast.error(err.response?.data?.message, {
          position: 'bottom-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <section className="widget full-width form-table">
        <header>
          <h3> Existing packages </h3>
        </header>
        <div className="packages-container">
          <form className="full-width">
            <div className="input-wrapper">
              <label>Name of the package</label>
              <input
                type="text"
                onChange={handleChange}
                value={packageName.package_name}
                name="package_name"
              />
            </div>
            <div className="input-wrapper">
              <label>Package Description</label>
              <input
                type="text"
                onChange={handleChange}
                value={packageName.notes}
                name="notes"
              />
            </div>
            <div className="input-wrapper">
              <label>Select package features:</label>
              <SubscriptionPackageFeatures
                handlePackageChange={handlePackageChange}
                value={packageName.feature_modules}
              />
            </div>
            <div className="cta-wrapper">
              <button
                className="submit"
                type="submit"
                disabled={isSubmitting}
                onClick={handleSubmit}
              >
                {isSubmitting ? 'Saving...' : 'Save'}
              </button>
            </div>
          </form>
        </div>
      </section>
      <ExistingPackages key={updated} />
    </>
  );
};

export { Packages };
